const SelectManualService = (state) => state.SelectManualService
const Rebook = (state) => state.Rebook
const PaxsGroup = (state) => state.PaxsGroup
export default {
  SelectManualService,
  Rebook,
  PaxsGroup
}
